import React, { useEffect } from 'react'
import dynamic from 'next/dynamic'
import Experiment, { useBucket } from '@mc/experiments-react'
import { EventTypes, getPageSource, track } from '@mc/track-event'

import type { CMTrailerHeroProps } from './CMTrailerHero'
import { CM_HERO_IS_A_TRAILER_FLAG } from './constants'

const CMTrailerHero = dynamic(
  () => import('./CMTrailerHero').then((m) => m.CMTrailerHero),
  { ssr: true },
)

type ExpProps = {
  Control: React.ComponentType
} & CMTrailerHeroProps

const CMHeroIsATrailerExperimentInner = ({
  Control,
  content,
  growthClass,
}: ExpProps) => {
  const isSkinHealth = content.slug === 'skin-health'

  const bucket = useBucket(CM_HERO_IS_A_TRAILER_FLAG)
  useEffect(() => {
    if (bucket && !isSkinHealth) {
      track(EventTypes.EXPERIMENT_VIEWED, {
        experimentName: `${CM_HERO_IS_A_TRAILER_FLAG}_fe`,
        variationName: bucket,
        page_source: getPageSource(),
      })
    }
  }, [bucket, isSkinHealth])

  if (isSkinHealth) {
    return <Control />
  }

  return (
    <Experiment
      name={CM_HERO_IS_A_TRAILER_FLAG}
      track={true}
      control={() => <Control />}
      variant_1={() => (
        <CMTrailerHero content={content} growthClass={growthClass} />
      )}
    />
  )
}

export const CMHeroIsATrailerExperiment = React.memo(
  CMHeroIsATrailerExperimentInner,
)
